export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YNpoik8s6yLUrwB0lw.09073c9e.woff2";